import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import Preview from './Preview';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import FormGuarantee from '../../../../view/FormGuarantee';
import converter from 'number-to-words';
import Data from '../../../../data/StateBoardResolutionToSell.json';
import moment from 'moment';
import Loading from '../../../../view/Loading';
import {Title} from '../../../../model/Helper';
import RequiredData from '../../../../model/RequiredData';
import FormFinal from '../../../../view/FormFinal';
import Meta from '../../../../model/Meta';

class BoardResolutionToSellStep4 extends Component {
    constructor(props) {
        super(props);
        this.state = Data;
    }

    componentWillMount() {

		if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details,
				meetingDate: data.meetingDate
			},			
				()=>{
					/**
					 * Check required data to create pdf
					 */
					RequiredData.property(this.state, this.state.formPath+"/1");
					RequiredData.corporation(this.state, this.state.formPath+"/2");
					RequiredData.price(this.state, this.state.formPath+"/3");
					RequiredData.area(this.state, this.state.formPath+"/3");
				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

	}

	componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

	handleChange(event) {
		const target = event.target;
	    const value = target.type === 'checkbox' ? target.checked : target.value;

	    this.setState({
			destinationEmail: value
		}, ()=>{
			let regex =/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if(regex.test(value)) {
				$(".download").addClass("btn-success").prop("disabled", false);
				$(".form-text").addClass("d-none");
			} else {
				$(".download").removeClass("btn-success").prop("disabled", true);
				$(".form-text").removeClass("d-none");
			}
		});
	}

	listOfBods() {

		let list = this.state.details.corporation.bod;
		let html = "";
		let blankLineLong = "_______________________________";
		html += `<br /><br /><table width="100%"><tbody><tr>`;
		for(let i=0; i<=(list.length-1); i++) {
			html +=`
				<td key=${i} width="50%">
					<div class="text-center td-spacing">
						<div>
							${blankLineLong}
						<div>
						<span class="dynamic-data font-weight-bold text-uppercase">${list[i]}</span><br />Director
					</div>
				</td>
			`;
			if(i===1 || i===3 || i===5 || i===7 || i===9 || i===11 || i===13 || i===15){
				html += "</tr><tr>"
			}
		}
		html +=`</tr></tbody></table>`;
		return html;
	}

    render() {
		let c = this.state.details.corporation;
		let p = this.state.details.property;

		let blankLine = "____________________";

		let title = (Title(p)) ? Title(p) : blankLine;

		let cName = (c.name) ? c.name : blankLine;
		let cAddress = (c.address) ? c.address : blankLine;

		let representativeMname = (c.representativeMname) ? " "+c.representativeMname : "";
		let representativeLname = (c.representativeLname) ? " "+c.representativeLname : "";
		let representativeSuffix = (c.representativeSuffix) ? " "+c.representativeSuffix : "";
		let cRepresentativePosition = (c.representativePosition) ? c.representativePosition : blankLine;
		let cRepresentativeName = (c.representativeFname || c.represemtativeMname || c.representativeLname) ? 
								(c.representativeFname+representativeMname+representativeLname+representativeSuffix): 
								blankLine;
		
		// Set date and date format
		let cBoardMeeting = blankLine;
		if(c.meetingDate) {
			cBoardMeeting = moment(c.meetingDate).format('LL');
		}

		let pAddress = (p.address) ? p.address : blankLine;
		let areaNumber = (typeof parseFloat(p.area) === "number" && parseFloat(p.area)>0) ? Number(p.area).toLocaleString() :
							blankLine;
		let areaText = (typeof parseFloat(p.area) === "number" && parseFloat(p.area)>0) ?
							converter.toWords(p.area) : 
							blankLine;
		let priceNumber = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ? Number(p.price).toLocaleString() :
							blankLine;		
		let priceText = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
							converter.toWords(p.price) : 
							blankLine;

		let contract_html = `
		<style type="text/css">
			@import url("./css/styles.css");
            @import url("./css/styles-custom.css");
		</style>
		<div class="pdf">

			<div class="paper">

				<div class="paper-title-no-underline text-center mt-0">
					${cName}
				</div>

				<div class="paper-title text-center">
					Board Resolution
				</div>

				<div>
					<p>
						We, the undersigned members of the Board of Directors of <span class="font-weight-bold dynamic-data text-uppercase">${cName}</span>, a domestic corporation duly organized and existing under and by virtue of the laws of the Republic of the Philippines, with principal office at <span class="dynamic-data text-capitalize">${cAddress}</span>, do hereby resolve, as follows:
					</p>
				</div>

				<div class="paper-narrow">
					<p>
						“RESOLVED, that the <span class="dynamic-data text-capitalize">${cRepresentativePosition}</span>, <span class="font-weight-bold dynamic-data text-uppercase">${cRepresentativeName}</span>, be authorized to act for and in behalf of the Corporation to SELL, TRANSFER and CONVEY to any interested person or entity who is willing, ready and able to buy, under such terms and conditions it may deem favorable, a real property owned and registered under the name of the Corporation, covered by <span class="dynamic-data text-capitalize">${title}</span> (hereinafter “Subject Real Property”), located at <span class="dynamic-data text-capitalize">${pAddress}</span>, with an area of <span class="dynamic-data text-uppercase">${areaText} (${areaNumber})</span> square meters, amounting to <span class="dynamic-data text-uppercase">${priceText} PESOS (P${priceNumber})</span> Philippine Currency;
					</p>
				</div>

				<div class="paper-narrow">
					<p>
						RESOLVED, FURTHER, that the <span class="dynamic-data text-capitalize">${cRepresentativePosition}</span>, in furtherance of and for the implementation of the power and authority granted, be allowed to sign, make, and execute such documents as may be necessary to carry into effect the sale of the Subject Real Property, and to accept and collect full payment, in the name of the corporation, the proceeds of the sale and sign for the receipt thereof; and
					</p>
				</div>

				<div class="paper-narrow">
					<p>        
						RESOLVED, FINALLY, that the <span class="dynamic-data text-capitalize">${cRepresentativePosition}</span> is authorized to do and perform any and all other lawful acts and deeds necessary to undertake the execution and finalization of the sale, transfer, or conveyance of the Subject Real Property.”
					</p>
				</div>
				
				<div class="my-5">
					<p>Approved and adopted on <span class="dynamic-data">${cBoardMeeting}</span>.</p>
				</div>

				<div class="w-100 mt-5 row">${this.listOfBods()}</div>

			</div>

		</div>
		`;
		
		let fn = "board_resolution_to_sell_contracts_ph_"+Date.now();
		let dn = this.state.formName;

		const meta = {
			title: "Your Board Resolution to Sell Contract is now ready",
			description: "Your Create your custom Board Resolution to Sell Contract for free is now ready for download"
		}

        return(
            <div className="page page-inner page-contract">
						<Meta {...meta}/>
				<Loading />
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">{this.state.formName}</h4>
                                <ContractCreate />
                                <ProgressBar percentage={Math.floor((4/4)*100)} />

                                {/* Final step starts here */}
                                <div className="my-5 text-center">
                                    <FormFinal 
                                        contract_html={contract_html} 
                                        fn={fn} 
                                        dn={dn} 
										formPath={this.state.formPath}
										details={this.state.details} />
                                </div>

								<FormGuarantee />

								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 4/4</p>
									<Link to={this.state.formPath+"/3"} className="btn btn-lightblue mr-2">Go Back and Edit</Link>
								</div>

                            </div>
                            <div className="col-12 col-md-7 right-preview">
                                <Preview {...this.state} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default BoardResolutionToSellStep4;


// WEBPACK FOOTER //
// ./src/pages/contracts/free-contracts/board-resolution-to-sell/BoardResolutionToSellStep4.js